export class SubCompanyAssignedAeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAssignedAe({ subCompanyId }) {
    return this.#http.get(`/api/sub-companies/${subCompanyId}/assigned-ae`);
  }

  // DEV-3636 broker-home AE relationship card — self-scoped from the JWT, no
  // subCompanyId path param. Returns { ae: {...} | null, asOfUtc }.
  async getAssignedAeCard({ config = {} } = {}) {
    return this.#http.get('/api/command-center/me/assigned-ae-card', config);
  }

  async setAssignedAe({ subCompanyId, aeUserId }) {
    return this.#http.put(`/api/sub-companies/${subCompanyId}/assigned-ae`, { aeUserId });
  }

  async getEligibleAes({ subCompanyId, search }) {
    return this.#http.get(`/api/sub-companies/${subCompanyId}/eligible-aes`, {
      params: { search },
    });
  }
}
